import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-615b6ab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Agreement name:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Organization:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Access started:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Access ended:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Access status:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedMembers, (memberGroup, groupIndex) => {
      return (_openBlock(), _createBlock(_component_q_card, { key: groupIndex }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(memberGroup[0].firstName) + " " + _toDisplayString(memberGroup[0].lastName) + " ", 1),
                _createVNode(_component_router_link, {
                  to: { name: _ctx.MembersRouteNames.SHOW, params: { memberId: memberGroup[0].memberId } },
                  target: "_blank",
                  title: "Show member in new tab"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "open_in_new",
                      class: "cursor-pointer"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("div", null, _toDisplayString(memberGroup[0].email), 1)
            ]),
            _: 2
          }, 1024),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberGroup, (member, index) => {
            return (_openBlock(), _createBlock(_component_q_card_section, {
              key: index,
              class: "agreement-member-record"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_2,
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(member.agreementName) + " ", 1),
                        _createVNode(_component_router_link, {
                          to: { name: _ctx.AgreementsRouteNames.SHOW, params: { agreementId: member.agreementId } },
                          target: "_blank",
                          title: "Show agreement in new tab"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "open_in_new",
                              class: "cursor-pointer"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_3,
                      _createElementVNode("td", null, _toDisplayString(member.organizationName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_4,
                      _createElementVNode("td", null, _toDisplayString(member.startDate), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_5,
                      _createElementVNode("td", null, _toDisplayString(member.endDate ?? '-'), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_6,
                      _createElementVNode("td", null, [
                        _createVNode(_component_q_badge, {
                          color: _ctx.accessStatusToColor(member.accessStatus)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(member.accessStatus), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}